import { Permission } from '@nextcloud/files';
/**
 * Check permissions on the node if it can be downloaded
 * @param node The node to check
 * @return True if downloadable, false otherwise
 */
export function isDownloadable(node) {
    if ((node.permissions & Permission.READ) === 0) {
        return false;
    }
    // check hide-download property of shares
    if (node.attributes['hide-download'] === true
        || node.attributes['hide-download'] === 'true') {
        return false;
    }
    // If the mount type is a share, ensure it got download permissions.
    if (node.attributes['share-attributes']) {
        const shareAttributes = JSON.parse(node.attributes['share-attributes'] || '[]');
        const downloadAttribute = shareAttributes.find(({ scope, key }) => scope === 'permissions' && key === 'download');
        if (downloadAttribute !== undefined) {
            return downloadAttribute.value === true;
        }
    }
    return true;
}
